import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { EmployeeCreatePage } from 'src/components/enterprise/features/Employee/CreatePage/EmployeeCreatePage';
import { EmployeeEditPage } from 'src/components/enterprise/features/Employee/EditPage/EmployeeEditPage';
import { EmployeeDetailsPage } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/EmployeeDetailsPage';
import { EmployeePaths } from 'src/components/AppRoutes/Enterprise/EmployeePaths';

export const EmployeeRoutes = (): JSX.Element | null => {
  const EmployeeCreatePageLayout = withEnterpriseLayout(EmployeeCreatePage);
  const EmployeeEditPageLayout = withEnterpriseLayout(EmployeeEditPage);
  const EmployeeDetailsPageLayout = withEnterpriseLayout(EmployeeDetailsPage);

  return (
    <Switch>
      <Route
        exact
        path={EmployeePaths.create}
        component={(): ReactElement => (
          <EmployeeCreatePageLayout pageTitle="Add New Employee" />
        )}
      />

      <Route
        exact
        path={EmployeePaths.edit}
        component={(): ReactElement => (
          <EmployeeEditPageLayout pageTitle="Edit Employee" />
        )}
      />

      <Route
        exact
        path={EmployeePaths.details}
        component={(): ReactElement => (
          <EmployeeDetailsPageLayout pageTitle="Employee Details" />
        )}
      />
    </Switch>
  );
};
